export const baseQuery = (req) =>
  req.then((response) => {
    if (!response.success) {
      return { error: response.data };
    }

    return { data: response?.data };
  });
